/* Merchant-supplied delivery ZIP policy. No customer data or credentials. */
window.SaberLocalDeliveryPolicy = {
  "sameDayPostalCodes": [
    "79821",
    "79835",
    "79836",
    "79838",
    "79901",
    "79902",
    "79903",
    "79904",
    "79905",
    "79906",
    "79907",
    "79908",
    "79910",
    "79911",
    "79912",
    "79913",
    "79914",
    "79915",
    "79916",
    "79917",
    "79918",
    "79920",
    "79922",
    "79923",
    "79924",
    "79925",
    "79926",
    "79927",
    "79928",
    "79929",
    "79930",
    "79931",
    "79932",
    "79934",
    "79935",
    "79936",
    "79937",
    "79938",
    "79940",
    "79941",
    "79942",
    "79943",
    "79944",
    "79945",
    "79946",
    "79947",
    "79948",
    "79949",
    "79950",
    "79951",
    "79952",
    "79953",
    "79954",
    "79955",
    "79958",
    "79960",
    "79961",
    "79966",
    "79968",
    "79973",
    "79974",
    "79975",
    "79976",
    "79977",
    "79978",
    "79980",
    "79982",
    "79983",
    "79984",
    "79985",
    "79986",
    "79987",
    "79988",
    "79989",
    "79990",
    "79991",
    "79992",
    "79993",
    "79994",
    "79995",
    "79996",
    "79997",
    "79998",
    "79999",
    "88003",
    "88004",
    "88005",
    "88006",
    "88007",
    "88008",
    "88011",
    "88012",
    "88013",
    "88063",
    "88510",
    "88511",
    "88512",
    "88513",
    "88514",
    "88515",
    "88516",
    "88517",
    "88518",
    "88519",
    "88520",
    "88521",
    "88523",
    "88524",
    "88525",
    "88526",
    "88527",
    "88528",
    "88529",
    "88530",
    "88531",
    "88532",
    "88533",
    "88534",
    "88535",
    "88536",
    "88538",
    "88539",
    "88540",
    "88541",
    "88542",
    "88543",
    "88544",
    "88545",
    "88546",
    "88547",
    "88548",
    "88549",
    "88550",
    "88553",
    "88554",
    "88555",
    "88556",
    "88557",
    "88558",
    "88559",
    "88560",
    "88561",
    "88562",
    "88563",
    "88565",
    "88566",
    "88567",
    "88568",
    "88569",
    "88570",
    "88571",
    "88572",
    "88573",
    "88574",
    "88575",
    "88576",
    "88577",
    "88578",
    "88579",
    "88580",
    "88581",
    "88582",
    "88583",
    "88584",
    "88585",
    "88586",
    "88587",
    "88588",
    "88589",
    "88590",
    "88595"
  ],
  "additionalClosures": [],
  "countryCodes": [
    "US"
  ],
  "timezone": "America/Denver",
  "cutoff": "11:59",
  "basis": "Merchant-defined estimate using native available/in-stock status and supplied ZIP list; no geographic or warehouse-stock verification"
};
